import colorsOptions from '../../fundamentals/colors-styles/constants'

export const DEFAULT_DELAY_DURATION = 700
export const TOOLTIP_OPEN = 'tooltip.open'

export const tooltipSideOptions = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
}

export const tooltipAlignOptions = {
  START: 'start',
  CENTER: 'center',
  END: 'end'
}

export const tooltipArrowAlignmentOptions = {
  START: 'start',
  CENTER: 'center',
  END: 'end'
}

export const tooltipColorOptions = {
  DEFAULT: 'default',
  INFO: 'info',
  DARNGER: 'danger',
  WARNING: 'warning',
  PLACEHOLDER: 'placeholder'
}

export const tooltipSizeOptions = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
}

export const tooltipSizeStyleOptions = {
  [tooltipSizeOptions.SMALL]: {
    padding: '4px'
  },
  [tooltipSizeOptions.MEDIUM]: {
    padding: '8px'
  },
  [tooltipSizeOptions.LARGE]: {
    padding: '12px'
  }
}

export const tooltipColorStyleOptions = {
  [tooltipColorOptions.DEFAULT]: {
    backgroundColor: colorsOptions.greys['grey-90']
  },
  [tooltipColorOptions.INFO]: {
    backgroundColor: colorsOptions.semantics.info.normal
  },
  [tooltipColorOptions.DARNGER]: {
    backgroundColor: colorsOptions.semantics.danger.error
  },
  [tooltipColorOptions.WARNING]: {
    backgroundColor: colorsOptions.semantics.warning.normal
  },
  [tooltipColorOptions.PLACEHOLDER]: {
    backgroundColor: colorsOptions.secondaryColors.petrol.strong
  }
}
